var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "user-search-container" },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            placeholder: _vm.placeholder,
            "remote-method": _vm.searchUsers,
            loading: _vm.loading,
            clearable: _vm.clearable,
          },
          on: { change: _vm.handleSelect, clear: _vm.handleClear },
          model: {
            value: _vm.selectedUserId,
            callback: function ($$v) {
              _vm.selectedUserId = $$v
            },
            expression: "selectedUserId",
          },
        },
        _vm._l(_vm.users, function (user) {
          return _c(
            "el-option",
            {
              key: user.userId,
              attrs: { label: _vm.formatUserLabel(user), value: user.userId },
            },
            [
              _c("div", { staticClass: "user-option" }, [
                _c("div", { staticClass: "user-info" }, [
                  _c("span", { staticClass: "user-name" }, [
                    _vm._v(
                      _vm._s(user.firstName) + " " + _vm._s(user.lastName)
                    ),
                  ]),
                  _c("span", { staticClass: "user-email" }, [
                    _vm._v(_vm._s(user.email || "No email")),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "user-meta" },
                  [
                    user.phoneNumber
                      ? _c("span", { staticClass: "user-phone" }, [
                          _vm._v(
                            _vm._s(user.countryCode) + _vm._s(user.phoneNumber)
                          ),
                        ])
                      : _vm._e(),
                    user.isPremium
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "warning" } },
                          [_vm._v("Premium")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        1
      ),
      _vm.selectedUser
        ? _c(
            "div",
            { staticClass: "selected-user-info" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 2, size: "mini", border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "Name" } }, [
                    _vm._v(
                      _vm._s(_vm.selectedUser.firstName) +
                        " " +
                        _vm._s(_vm.selectedUser.lastName)
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "Email" } }, [
                    _vm._v(_vm._s(_vm.selectedUser.email || "N/A")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "Phone" } }, [
                    _vm._v(
                      _vm._s(_vm.selectedUser.countryCode) +
                        _vm._s(_vm.selectedUser.phoneNumber || "N/A")
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "User ID" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "font-family": "monospace",
                        },
                      },
                      [_vm._v(_vm._s(_vm.selectedUser.userId))]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }